import { apolloClient } from '@/services/apollo-client'
import { POST_JOB, UPDATE, SAVE_DRAFT, UPDATE_DRAFT, EDIT_POST_JOB } from "@/graphql/jobpost/post";

export const postJob = (form) => {
    return new Promise(async (resolve, reject) => {
        try {
            const res = await apolloClient.mutate({
                mutation: POST_JOB,
                variables: form
            })
            resolve(res.data.addJob)
        } catch (e) {
            reject(e)
        }
    })
}

export const get_Edit_Job = (form) => {
    return new Promise(async (resolve, reject) => {
        try {
            const res = await apolloClient.query({
                query: EDIT_POST_JOB,
                variables: form
            })
            resolve(res.data.getjobSearch)
        } catch (e) {
            reject(e)
        }
    })
}

export const update_PostJob = (form) => {
    return new Promise(async (resolve, reject) => {
        try {
            const res = await apolloClient.mutate({
                mutation: UPDATE,
                variables: form
            })
            resolve(res.data.updateJob)
        } catch (e) {
            reject(e)
        }
    })
}

export const saveToDraft = (form) => {
    return new Promise(async (resolve, reject) => {
        try {
            const res = await apolloClient.mutate({
                mutation: SAVE_DRAFT,
                variables: form
            })
            resolve(res.data.saveDraft)
        } catch (e) {
            reject(e)
        }
    })
}

export const updateDraft = (form) => {
    return new Promise(async (resolve, reject) => {
        try {
            const res = await apolloClient.mutate({
                mutation: UPDATE_DRAFT,
                variables: form
            })
            resolve(res.data.saveDraft)
        } catch (e) {
            reject(e)
        }
    })
}